<template>
  <div>
    <b-table-filter
      :items="rows"
      :fields="fields"
      title="Báo Cáo Đơn Hàng Chưa Xử Lý"
      :perPage="perPage"
      :pageLength="pageLength"
      :isBusy="busy"
      :totalRows="totalRow"
    >
      <!-- <template #rightAction>
        <div>
          <b-button size="sm" variant="info"><feather-icon icon="CalendarIcon" /> Hôm Nay</b-button>
          <b-button size="sm"  variant="success"><feather-icon icon="CalendarIcon" /> Tuần Này</b-button>
          <b-button size="sm" variant="warning"><feather-icon icon="CalendarIcon" /> Tháng Này</b-button>
          <b-button size="sm"><feather-icon icon="CalendarIcon" /> Tháng Trước</b-button>
        </div>
      </template> -->
      <template #filterTable>
        <td style="width: 15%">
          <b-form-datepicker placeholder="Từ Ngày" size="sm" v-model="fromDate" />
        </td>
        <td style="width: 15%">
          <b-form-datepicker placeholder="Đến Ngày" size="sm" v-model="toDate" />
        </td>
        <td>
          Nếu không chọn Ngày Sẽ Lấy 5 ngày gần Nhất
        </td>
        <td>
          <div style="float:right">
            <b-button variant="warning" @click="onSubmitFilter" style="margin-right: 5px"><feather-icon icon="SearchIcon" /> Xem Báo Cáo</b-button>
          </div>
        </td>
      </template>
    </b-table-filter>
  </div>
</template>

<script>
import {
  BFormDatepicker, BButton, BAlert,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

import BTableFilter from '@/@core/components/datatable/BTableFilter.vue'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'

export default {
  components: {
    BFormDatepicker,
    BButton,
    BTableFilter,
    FeatherIcon,
    BAlert,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      perPage: 10,
      busy: false,
      totalRow: 1,
      pageLength: 10,
      dir: false,
      fields: [
        {
          label: 'STT',
          key: 'id',
        },
        {
          label: 'Mã Đơn Hàng',
          key: 'orderCode',
        },
        {
          label: 'Số Điện Thoại',
          key: 'phone',
        },
        {
          label: 'Khách Hàng',
          key: 'customer',
        },
        {
          label: 'Trạng Thái',
          key: 'status',
        },
        {
          label: 'Kênh',
          key: 'channel',
        },
        {
          label: 'Người Tạo',
          key: 'status',
        },
        {
          label: 'Ngày Tạo',
          key: 'createdAt',
        },
        {
          label: 'Chia Cho',
          key: 'customerdis',
        },
        {
          label: 'Ngày Chia',
          key: 'datedis',
        },
      ],
      rows: [],
      fromDate: null,
      toDate: null,
    }
  },
  computed: {
  },
  created() {
  },
  methods: {
    onSubmitFilter() {
      this.busy = false
      console.log('onSubmitFilter', this.fromDate, this.toDate)
      
      this.rows = [
        {
          id: 1,
          orderCode: 12222,
          customer: 'Danh Sinh',
          phone: '096-998-5002',
          paid: 90000,
          courseCount: 10,
          status: 'Đã Xác Nhận',
          channel: 'Tạo Tay',
          createdAt: '20/02/2022',
          customerdis: 'Ảo Ảnh ',
          datedis: '20/03/2022',
        }
      ]
    },
    onReset() {
      this.fromDate = null
      this.toDate = null
    },
  },
}
</script>
